export class UtilsHelper {
    /**
     * Method to get random number value to replace Math.random()
     * @returns number
     */
    public static GetRandomValue(): number {
        const crypto = window.crypto;
        return crypto.getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
    }
}
